export enum EPropertyType {
  Boolean = 'BOOL',
  Numeric = 'NUM',
  String = 'STR',
  Enum = 'ENUM',
  Single = 'SNG',
  Multiple = 'MUL',
}

export enum EPropertyApplicability {
  Master = 'MSTR',
  NumericMaster = 'NMSTR',
  Feature = 'FTR',
  Option = 'OPT',
  Product = 'PROD',
  String = 'STR',
  Numeric = 'NUM',
}

export enum EMasterPropertyCodes {
  AgCode = 'AGC',
  RCID = 'RCI',
}

export enum EPropertyGroup {
  Master = 'Master',
  Product = 'Product',
  Download = 'Download',
}

export enum EAssociationType {
  Boolean = 'Boolean',
  String = 'String',
  Enum = 'Enum',
  Number = 'Number',
}

export enum EPropertyActionType {
  Update = 'Update',
  Add = 'Add',
  Delet = 'Delete',
}

export const ShowOptionCodeForProperties = ['ERO', 'AGC', 'RCI'];

export const DefaultAssignmentIcon = 'D';

export const EDisabledProperties = {
  [EPropertyApplicability.Product]: ['CHT'],
};

export enum EViews {
  Master = 'MASTER',
}

export enum ELovCodes {
  Econ = 'ECON',
}
